import AboutTwo from "../Components/About/AboutTwo";
import ServicesTwo from "../Components/Services/ServicesTwo";
import CtaOne from "../Components/Cta/CtaOne";
import BrandCarouselTwo from "../Components/Brands/BrandCarouselTwo";
import ProjectsTab from "../Components/Projects/ProjectsTab";
import FooterTwo from "../Components/Footer/FooterTwo";
import BlogTwo from "../Components/Blog/BlogTwo";
import TeamTwo from "../Components/Team/TeamTwo";
import WhyUs from "../Components/About/WhyUs";
import FunFact from "../Components/FunFact/FunFact";
import PortfolioTwo from "../Components/Portfolio/PortfolioTwo";
import HeaderTwo from "../Components/Header/HeaderTwo";
import HeroTwo from "../Components/Hero/HeroTwo";

const HomeTwo = () => {
    return (
        <>
            <HeaderTwo/>
            <HeroTwo/>
            <AboutTwo/>
            <ServicesTwo/>
            <CtaOne/>
            <BrandCarouselTwo/>
            <ProjectsTab/>
            <FunFact/>
            <WhyUs/>
            <TeamTwo/>
            <PortfolioTwo/>
            <BlogTwo/>
            <FooterTwo/>
        </>
    )
}

export default HomeTwo;